import axiosInstance from '@/api/apiClient'
import type {
  BuildStep,
  ReviewStep,
  WorldGraphEdge,
  WorldGraphNode,
  WorldGraphState,
} from '../types'

const base = (roomId: string) => `/oge/rooms/${roomId}/world-graph/`

export interface WorldGraphEdits {
  enabled?: boolean
  scenario_document?: string
  sidecar?: string
  nodes?: Partial<WorldGraphNode>[]
  edges?: Partial<WorldGraphEdge>[]
}

export const getWorldGraph = (roomId: string) =>
  axiosInstance.get<WorldGraphState>(base(roomId))

export const updateWorldGraph = (roomId: string, data: WorldGraphEdits) =>
  axiosInstance.patch<WorldGraphState>(base(roomId), data)

export const generateStep = (roomId: string, step: BuildStep) =>
  axiosInstance.post<WorldGraphState>(`${base(roomId)}${step}/generate/`)

export const approveStep = (
  roomId: string,
  step: ReviewStep,
  data: WorldGraphEdits = {}
) =>
  axiosInstance.post<WorldGraphState>(`${base(roomId)}${step}/approve/`, data)

/** Roster team id to a room team id, or null for a new team. */
export type TeamLinks = Record<string, number | null>

export const setUpTeams = (roomId: string, links: TeamLinks) =>
  axiosInstance.post<WorldGraphState>(`${base(roomId)}teams/`, { links })

export type RoundAction = 'propose' | 'apply' | 'undo' | 'write' | 'release'

export interface RoundEdits {
  proposals?: {
    key: string
    include?: boolean
    nodes_delta?: Record<string, number>
  }[]
  artifacts?: {
    id: string
    title?: string
    text?: string
    include?: boolean
    audience?: { all: boolean; teams: number[] }
  }[]
}

export const roundAction = (
  roomId: string,
  round: number,
  action: RoundAction,
  data: { ids?: string[] } = {}
) =>
  axiosInstance.post<WorldGraphState>(
    `${base(roomId)}rounds/${round}/${action}/`,
    data
  )

export const editRound = (roomId: string, round: number, data: RoundEdits) =>
  axiosInstance.patch<WorldGraphState>(`${base(roomId)}rounds/${round}/`, data)

export const resetWorld = (roomId: string) =>
  axiosInstance.post<WorldGraphState>(`${base(roomId)}reset-world/`)

export const reopenStep = (roomId: string, step: ReviewStep) =>
  axiosInstance.post<WorldGraphState>(`${base(roomId)}${step}/reopen/`)
